import React, { useEffect, useState } from "react";

const steps = [
  {
    id: "campaign-select",
    title: "Select Campaign",
    description: "Select a campaign to view your pipeline",
  },
];

function PipelineGuide({ stepIndex, onNext, onClose }) {
  const [rect, setRect] = useState(null);

  const step = steps[stepIndex];

  const updatePosition = () => {
    const el = document.querySelector(`[data-guide="${step?.id}"]`);
    if (!el) return;

    const r = el.getBoundingClientRect();
    setRect(r);
  };

  useEffect(() => {
    updatePosition();

    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition);

    return () => {
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition);
    };
  }, [stepIndex]);

  if (!step || !rect) return null;

  // 📱 Responsive positioning logic
  const isMobile = window.innerWidth < 640;

  const tooltipTop = isMobile
    ? rect.bottom + 12
    : rect.bottom + 16;

  const tooltipLeft = isMobile
    ? 16
    : rect.left;

  const pointerLeft = rect.left + rect.width / 2;

  return (
    <>
      {/* Overlay */}
      <div className="fixed inset-0 bg-black/40 z-[100]" />

      {/* Tooltip */}
      <div
        className="fixed z-[101] bg-white rounded-xl shadow-xl p-4 w-[90%] max-w-xs"
        style={{
          top: tooltipTop,
          left: tooltipLeft,
        }}
      >
        <p className="font-semibold text-gray-900">{step.title}</p>
        <p className="text-sm text-gray-600 mt-1">{step.description}</p>

        <div className="flex justify-between items-center mt-3">
          <button
            onClick={onClose}
            className="text-sm text-gray-500"
          >
            Skip
          </button>
          <button
            onClick={onNext}
            className="bg-orange-500 text-white px-3 py-1 rounded-lg text-sm"
          >
            Got it
          </button>
        </div>
      </div>

      {/* 👇 Finger Pointer */}
      <div
        className="fixed z-[101] text-3xl animate-bounce"
        style={{
          top: rect.top - 40,
          left: pointerLeft,
          transform: "translateX(-50%)",
        }}
      >
        👇
      </div>
    </>
  );
}

export default PipelineGuide;